/*
  the following load more functionality leverages the Shopify Section Rendering API
  for async pagiation of the Order History Page more info here: https://shopify.dev/api/section-rendering

  this is very helpful and concice youtube video that explains PLP usecases for the
  Section Rendering API: https://www.youtube.com/watch?v=0eFhWtpoZQc&ab_channel=CodewithChristheFreelancer
*/

const loadMoreButton = document.querySelector('.js-order-history-load-more')
const loadMoreProgressBar = document.querySelector(
  '.js-order-pagination-progress__bar'
)
const pageToLoad = loadMoreButton.dataset.pageToLoad

const updateProgressBar = (newTotalLoaded, totalCustomerOrders) => {
  const newWidth = (newTotalLoaded / totalCustomerOrders) * 100

  loadMoreProgressBar.style.width = `${newWidth}%`
}

loadMoreButton.addEventListener('click', (e) => {
  e.preventDefault()

  const url = pageToLoad

  fetch(url)
    .then((res) => res.text())
    .then((responseText) => {
      const new_html = new DOMParser()
        .parseFromString(responseText, 'text/html')
        .getElementById('order-history').innerHTML

      document
        .getElementById('order-history')
        .insertAdjacentHTML('beforeend', new_html)
    })

  const newTotalLoaded = Number(loadMoreButton.dataset.totalLoaded) + 2
  const totalCustomerOrders = loadMoreButton.dataset.totalCustomerOrders
  const hideButton = newTotalLoaded >= Number(totalCustomerOrders)
  loadMoreButton.dataset.totalLoaded = newTotalLoaded

  updateProgressBar(newTotalLoaded, totalCustomerOrders)

  if (hideButton) {
    loadMoreButton.classList.add('order-history__load-more-button--hidden')
    document.querySelector('.order-pagination-progress').classList.add('hidden')
  }
})

updateProgressBar(2, loadMoreButton.dataset.totalCustomerOrders)
